import BaseTable from 'components/Tables/BaseTable';
import { sortBy } from 'lodash';
import FlowListDetailPanel from 'pages/ScenarioExposure/Flow/ScenariosManagement/FlowListDetailPanel';
import React, { useRef } from 'react';
import { connect } from 'react-redux';
import theme from 'source/theme';
import tableIcons from 'utils/icons/materialTableIcons';
import columns from 'utils/tables/columns/scenarioExposure/flow/flowPcSuScenarioDescriptorExposure';

const Component = props => {
  const {
    descriptorId, descriptorsById, descriptorsData, descriptorFilter, scenariosById,
    flowScenarioDescriptors, flowsById, TABLE_HEIGHT
  } = props;

  const { setDescriptorId } = props;
  const tableRef = useRef();

  const filteredDescriptors = descriptorsData.filter(v => v.id_tipo === descriptorFilter);
  const filteredDescriptorsIds = filteredDescriptors.map(fD => fD.id);
  const filteredSD = flowScenarioDescriptors.filter(fSD => filteredDescriptorsIds.includes(fSD.id_descritor))

  const mergedProductDescriptors = [];
  const descriptorRepetitions = [];

  filteredSD.forEach(fSD => {
    if (!descriptorRepetitions.includes(fSD.id_descritor)) {
      const scenariodescriptorGrouped = filteredSD.filter(item => item.id_descritor === fSD.id_descritor);
      const mergedDescriptor = {
        id: fSD.id_descritor,
        descriptor_code: descriptorsById[fSD.id_descritor].codigo,
        descriptor_description: descriptorsById[fSD.id_descritor].descricao,
        flowsInfo: []
      };

      const repeatedFlows = [];
      scenariodescriptorGrouped.forEach(sdg => {
        const flow = flowsById[scenariosById[sdg.id_cenario].id_fluxograma];
        if (!repeatedFlows.includes(flow.id)) {
          mergedDescriptor.flowsInfo.push({
            code: flow.codigo_fluxo,
            name: flow.nome
          });
          repeatedFlows.push(flow.id);
        }
      });

      descriptorRepetitions.push(fSD.id_descritor);
      mergedProductDescriptors.push(mergedDescriptor);
    }
  });

  const rows = sortBy(mergedProductDescriptors, ['id']);

  return (
    <React.Fragment>
      <BaseTable
        ref={tableRef}
        title={'DESCRITORES DO FLUXO'}
        columns={columns}
        data={rows}
        paging={false}
        onRowClick={() => null}
        onRowDoubleClick={setDescriptorId ? rowData => setDescriptorId(rowData.id) : null}
        options={{
          // toolbar: false,
          // search: false,
          maxBodyHeight: TABLE_HEIGHT,
          minBodyHeight: TABLE_HEIGHT,
          rowStyle: setDescriptorId ? rowData => ({
              backgroundColor: (rowData.id === descriptorId) ?
                theme.palette.primary.light :
                theme.palette.background.veryLight
            }) :
            ({ backgroundColor: theme.palette.background.veryLight })
        }}
        detailPanel={[
          () => ({
            icon: tableIcons.Flow,
            tooltip: 'Fluxogramas',
            render: rowData => <FlowListDetailPanel row={rowData}/>
          })
        ]}
      />
    </React.Fragment>
  )
};


const mapStateToProps = (state) => ({
  descriptorsData: state.descriptors.data,
  descriptorsById: state.descriptors.dataById,
  scenariosById: state.scenarios.dataById,
  flowsById: state.flows.dataById
})

export default connect(mapStateToProps)(Component);
